import { angularInjectorProvider } from 'Injector';
import { type StatusPoller } from './Status.types';

export function useSendPing() {
    const StatusPoller = angularInjectorProvider.get<StatusPoller>('FrontRoyal.StatusPoller');

    return {
        sendPing: () => StatusPoller.send(),
    };
}
